module.exports = __webpack_public_path__ + "img/mrmoney.8e3464f9.webp";